export default __webpack_public_path__ + "static/media/FullStone.17dce4cd.png";